import React from 'react';
import { connect } from 'react-redux';
import { Spacer } from '@zillow/constellation';

import ListingHeader from 'app/shared/components/postingPath/ListingHeader';
import ListingTour from 'app/shared/components/postingPath/ListingTour';
import ListingStatusBanner from 'app/shared/components/postingPath/ListingStatusBanner';
import ListingStats from 'app/shared/components/postingPath/ListingStats';
import FloorplansMF from 'app/shared/components/postingPath/FloorplansMF';
import UnitsSection from 'app/shared/components/postingPath/UnitsSection';
import userUtils from 'app/shared/utils/userUtils';
import { AppSelectors, UserSelectors } from 'app/shared/selectors';
import { StyledHR } from 'app/shared/StyledComponents/StyledComponents';

import PropertyConstants from 'app/shared/constants/PropertyConstants';

const { SYNDICATION_OVERVIEW_STATUS } = PropertyConstants;

const NotViewableContent = ({
    errorObj,
    formData,
    getActiveFloorplanOrUnitCount,
    isAddingUnit,
    isArchived,
    isListingPhotoProcessing,
    isScreenSM,
    isScreenXS,
    saveFloorplanData,
    updateErrorObj,
    updateFormData,
    updateListingPhotoProcessingStatus,
    updateParentFloorplanPrice,
    updateOnFocus,
    updateStatusMessage,
    user,
    validateFloorplan,
    validateFloorplans,
    validateUnit,
}) => {
    const {
        feedName,
        isCommunity,
        restrictions: {
            isUpdateListingRestricted,
        },
        syndication,
    } = formData;
    const { roles, isEnterpriseCustomer } = user;
    const isInputFormDisabled = isArchived || isUpdateListingRestricted;
    const isAdmin = userUtils.isPostingPathAdmin(roles);
    const hasFloorPlans = formData.floorplans.length > 0;
    const showFloorPlans = hasFloorPlans && isCommunity;
    const hasUnits = formData.units.length > 0;

    return (
        <Spacer paddingX={0} className="EditListingPage-NotEditable-Container">
            {(syndication.status !== SYNDICATION_OVERVIEW_STATUS.INACTIVE) && (
                <ListingStatusBanner universal={syndication.universal} />
            )}
            <ListingHeader title={`Source: ${feedName}`} formData={formData} />
            {isEnterpriseCustomer && <ListingStats listing={formData} />}
            <ListingTour
                tours={formData.tours}
                tourType={isCommunity ? 'amenity' : 'singleFamily'}
                isDisabled={isInputFormDisabled}
                updateStatusMessage={updateStatusMessage}
                updateFormData={updateFormData}
                formData={formData}
            />
            {(showFloorPlans || hasUnits) && (
                <React.Fragment>
                    <StyledHR />
                    {showFloorPlans && (
                        <FloorplansMF
                            canEditTourOverwrite={!isInputFormDisabled}
                            errorObj={errorObj}
                            formData={formData}
                            getActiveFloorplanOrUnitCount={getActiveFloorplanOrUnitCount}
                            isAddingUnit={isAddingUnit}
                            isInputFormDisabled={true}
                            isListingPhotoProcessing={isListingPhotoProcessing}
                            isMobile={isScreenXS || isScreenSM}
                            isPostingPathAdmin={isAdmin}
                            propertyId={formData.propertyId}
                            saveFloorplanData={saveFloorplanData}
                            updateErrorObj={updateErrorObj}
                            updateFormData={updateFormData}
                            updateListingPhotoProcessingStatus={updateListingPhotoProcessingStatus}
                            updateOnFocus={updateOnFocus}
                            updateParentFloorplanPrice={updateParentFloorplanPrice}
                            updateStatusMessage={updateStatusMessage}
                            validateFloorplan={validateFloorplan}
                            validateFloorplans={validateFloorplans}
                            validateUnit={validateUnit}
                        />
                    )}
                    {hasUnits && (
                        <UnitsSection
                            formData={formData}
                            isMobile={isScreenXS || isScreenSM}
                            isPostingPathAdmin={isAdmin}
                            isInputFormDisabled={true}
                            canEditTourOverwrite={!isInputFormDisabled}
                        />
                    )}
                </React.Fragment>
            )}
        </Spacer>
    );
};

const mapStateToProps = state => ({
    isScreenXS: AppSelectors.makeIsScreenXS(state),
    isScreenSM: AppSelectors.makeIsScreenSM(state),
    user: UserSelectors.makeUser(state),
});


export default connect(mapStateToProps)(NotViewableContent);
